import Jpeg from './jpeg'
import Pdf from './pdf'
import Png from './png'
import Unknown from './unknown'
import Mp4 from './mp4'
import AI from './ai'
import Avi from './avi'
import Css from './css'
import Eps from './eps'
import Gif from './gif'
import Doc from './doc'
import Docx from './docx'
import Indd from './indd'
import Ppt from './ppt'
import Psd from './psd'
import Xls from './xls'
import Zip from './zip'
import Mp3 from './mp3'
import Mov from './mov'
import Wmv from './wmv'
import Tiff from './tiff'
import Wav from './wav'
import Txt from './txt'
import Otf from './otf'
import Ttf from './ttf'

export {
  Jpeg,
  Pdf,
  Png,
  Unknown,
  Mp4,
  AI,
  Avi,
  Css,
  Eps,
  Gif,
  Doc,
  Docx,
  Indd,
  Ppt,
  Psd,
  Xls,
  Zip,
  Mp3,
  Mov,
  Wmv,
  Tiff,
  Wav,
  Txt,
  Otf,
  Ttf
}



// WEBPACK FOOTER //
// ./src/components/Svg/index.js